export enum EventSubType {
  group = 'group',
  project = 'project'
}
